
export const localStorageKey = 'musical-'
